import React, { useState, useEffect } from "react";
import classnames from "classnames";
import {
  Card, CardBody, Col, Container, Row, Nav, NavItem, NavLink,
  TabContent, TabPane, Form, Label, Input, Button, Spinner, FormGroup
} from "reactstrap";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import { API_BASE, changePasswordRequest } from "../../helpers/auth_client";

const Hesabim = () => {
  document.title = "Hesabım | LojGo";

  const [activeTab, setActiveTab] = useState("5"); // Test için direkt 5. sekmeyi (Faturalandırma) açıyoruz
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  
  // Tabloların ID'leri (Güncelleme işlemleri için)
  const [dbIds, setDbIds] = useState({
    userId: null,
    addressId: null,
    licenseId: null,
    bankId: null,
    companyId: null,
    invoiceId: null
  });

  const [formData, setFormData] = useState({
    email: "", currentPassword: "", password: "", firstName: "", lastName: "", phone: "",
    city: "", addressText: "",
    licenseNumber: "", licenseClass: "",
    
    // --- FİRMA VE FATURA BİLGİLERİ ---
    companyType: "Serbest meslek sahibi",
    companyNumber: "", // Vergi / Şirket No
    vatNumber: "",     // KDV Numarası
    taxOffice: "",     // Vergi Dairesi
    companyName: "",   // Şirket Adı
    companyAddress: "",// Şirket Adresi
    
    // --- BANKA BİLGİLERİ ---
    iban: "", bankName: "", holderName: "",
    
    // UI'da olan ek alanlar
    subjectToVAT: "true",
    invoicingMandate: "true",
    companyCapital: ""
  });

  const toggleTab = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Verileri OData'dan Çekme
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const id = authUser?.ID;
        
        if (!id) return;

        const response = await fetch(
          `https://hiflowapi.stechomeyazilim.info/Users?$filter=ID eq ${id}&$expand=Users_Address,Users_Driving_License,Users_BankAccount,Users_Company($expand=Users_Invoince)`
        );
        const result = await response.json();

        if (result && result.value && result.value.length > 0) {
          const data = result.value[0]; 

          const addr = data.Users_Address?.[0] || {};
          const license = data.Users_Driving_License?.[0] || {};
          const bank = data.Users_BankAccount?.[0] || {};
          const comp = data.Users_Company?.[0] || {};
          const inv = comp.Users_Invoince?.[0] || data.Users_Invoince?.[0] || {};

          setDbIds({
            userId: id,
            addressId: addr.ID || null,
            licenseId: license.ID || null,
            bankId: bank.ID || null,
            companyId: comp.ID || null,
            invoiceId: inv.ID || null
          });

          setFormData(prev => ({
            ...prev,
            email: data.Users_Email || "",
            phone: data.Users_PhoneNumber || "",
            firstName: data.Users_NameSurname?.split(' ')[0] || "",
            lastName: data.Users_NameSurname?.split(' ').slice(1).join(' ') || "",
            
            city: addr.Users_Address_City || "",
            addressText: addr.Users_Address_AdressText || "",

            licenseNumber: license.Driving_License_Number || "",
            licenseClass: license.Driving_License_Class || "B",

            // Şirket ve Fatura
            companyName: comp.Users_Company_Name || "",
            companyNumber: inv.KdvNumber || "", // Vergi no olarak KdvNumber kolonunu kullanıyoruz
            vatNumber: inv.KdvNumber || "", 
            taxOffice: inv.VergiDairesi || "",
            companyAddress: inv.Adres || "",

            // Banka
            iban: bank.Users_BankAccount_Iban || inv.Iban || "",
            bankName: bank.Users_BankAccount_BankName || "",
            holderName: bank.Users_BankAccount_HolderName || ""
          }));
        }
      } catch (error) {
        console.error("Kullanıcı verileri çekilemedi:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchUserData();
  }, []);

  // Formu Kaydetme (Şirket Bilgilerini de veritabanına yazar)
  const handleSave = async () => {
    if (!dbIds.userId) return;
    setIsSaving(true);

    try {
      // 1. Ana Kullanıcı Güncellemesi
      // PUT tüm varlığı ezdiği için (rol ve şifre dahil) API'de kapatıldı; PATCH kullanılıyor.
      const userPayload = {
        Users_NameSurname: `${formData.firstName} ${formData.lastName}`.trim(),
        Users_PhoneNumber: formData.phone,
      };

      await fetch(`${API_BASE}/Users(${dbIds.userId})`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(userPayload)
      });

      // Şifre artık kullanıcı kaydının bir alanı olarak yazılamıyor; ayrı uçtan,
      // mevcut şifre doğrulanarak değiştiriliyor ve sunucuda hash'leniyor.
      if (formData.password.trim() !== "") {
        if (!formData.currentPassword || !formData.currentPassword.trim()) {
          throw new Error("Şifrenizi değiştirmek için mevcut şifrenizi girmelisiniz.");
        }
        await changePasswordRequest(formData.currentPassword, formData.password);
      }

      // 2. Ehliyet Bilgisi
      const licensePayload = {
        Users_ID: dbIds.userId,
        Driving_License_Number: formData.licenseNumber,
        Driving_License_Class: formData.licenseClass
      };
      await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Driving_License${dbIds.licenseId ? `(${dbIds.licenseId})` : ''}`, {
        method: dbIds.licenseId ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(licensePayload)
      });

      // 3. Banka Bilgisi
      const bankPayload = {
        Users_ID: dbIds.userId,
        Users_BankAccount_Iban: formData.iban,
        Users_BankAccount_BankName: formData.bankName,
        Users_BankAccount_HolderName: formData.holderName
      };
      await fetch(`https://hiflowapi.stechomeyazilim.info/Users_BankAccount${dbIds.bankId ? `(${dbIds.bankId})` : ''}`, {
        method: dbIds.bankId ? "PUT" : "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(bankPayload)
      });

      // 4. ŞİRKET BİLGİSİ (Users_Company)
      let currentCompanyId = dbIds.companyId;
      const compPayload = {
        Users_ID: dbIds.userId,
        Users_Company_Name: formData.companyName
      };

      if (currentCompanyId) {
        // Varsa Güncelle (PUT)
        await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Company(${currentCompanyId})`, {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(compPayload)
        });
      } else {
        // Yoksa Yeni Firma Oluştur (POST) ve ID'sini al
        const compRes = await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Company`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(compPayload)
        });
        const newComp = await compRes.json();
        currentCompanyId = newComp.ID; 
        setDbIds(prev => ({ ...prev, companyId: currentCompanyId }));
      }

      // 5. FATURA BİLGİSİ (Users_Invoince)
      if (currentCompanyId) {
          const invPayload = {
            Users_Company_ID: currentCompanyId, // Faturayı Şirkete Bağlıyoruz
            KdvNumber: formData.vatNumber || formData.companyNumber,
            VergiDairesi: formData.taxOffice,
            Adres: formData.companyAddress,
            Iban: formData.iban // Invoince tablosunda da Iban kolonu var, oraya da yazıyoruz
          };
          
          await fetch(`https://hiflowapi.stechomeyazilim.info/Users_Invoince${dbIds.invoiceId ? `(${dbIds.invoiceId})` : ''}`, {
            method: dbIds.invoiceId ? "PUT" : "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(invPayload)
          });
      }

      alert("Tüm firma ve kişisel bilgileriniz başarıyla kaydedildi.");
    } catch (error) {
      console.error("Kaydetme hatası:", error);
      alert("Bilgiler güncellenirken bir hata oluştu.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h2>hesabım</h2>
            <Button color="light" size="sm" className="text-primary border-primary bg-transparent fw-medium">
              <i className="mdi mdi-help-circle-outline me-1"></i> Hesabımı yönetme hakkında daha fazla bilgi edinin
            </Button>
          </div>

          <Row>
            <Col lg="12">
              <Card className="shadow-sm">
                <CardBody className="pt-0 pb-0 border-bottom">
                  <Nav tabs className="nav-tabs-custom border-bottom-0">
                    <NavItem><NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggleTab("1")} style={{ cursor: 'pointer' }}>Genel profil</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "2" })} onClick={() => toggleTab("2")} style={{ cursor: 'pointer' }}>Sürücü profili</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "3" })} onClick={() => toggleTab("3")} style={{ cursor: 'pointer' }}>Uyarılar</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "4" })} onClick={() => toggleTab("4")} style={{ cursor: 'pointer' }}>Belgeler</NavLink></NavItem>
                    <NavItem><NavLink className={classnames({ active: activeTab === "5" })} onClick={() => toggleTab("5")} style={{ cursor: 'pointer' }}>Faturalandırma</NavLink></NavItem>
                  </Nav>
                </CardBody>

                <CardBody className="min-vh-50">
                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TabContent activeTab={activeTab}>
                      
                      {/* ... DİĞER SEKMELER (1,2,3,4) AYNI KALACAK (Önceki kodla birebir aynı) ... */}
                      <TabPane tabId="1">
                        <div className="bg-light p-3 rounded mb-4 text-dark fw-medium">
                          <i className="mdi mdi-information text-dark me-2"></i> Konveyör profilinizin genel bilgilerini doldurun.
                        </div>
                        <div className="border-bottom pb-4 mb-4">
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">E-posta</Label>
                                <Col sm={5}><Input type="email" value={formData.email} disabled className="bg-light" /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Mevcut şifre</Label>
                                <Col sm={5}>
                                    <Input type="password" name="currentPassword" value={formData.currentPassword} onChange={handleInputChange} autoComplete="current-password" />
                                    <small className="text-muted">Yalnızca şifrenizi değiştirecekseniz doldurun.</small>
                                </Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Yeni şifre</Label>
                                <Col sm={5}>
                                    <Input type="password" name="password" value={formData.password} onChange={handleInputChange} />
                                    <small className="text-muted d-block mt-2">(şifrenizi değiştirmek istemiyorsanız bu alanı boş bırakın)</small>
                                </Col>
                            </FormGroup>
                        </div>
                        <div className="border-bottom pb-4 mb-4">
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Ad</Label>
                                <Col sm={5}><Input type="text" name="firstName" value={formData.firstName} onChange={handleInputChange} /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Soyad</Label>
                                <Col sm={5}><Input type="text" name="lastName" value={formData.lastName} onChange={handleInputChange} /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Telefon</Label>
                                <Col sm={5}><Input type="text" name="phone" value={formData.phone} onChange={handleInputChange} /></Col>
                            </FormGroup>
                        </div>
                      </TabPane>
                      <TabPane tabId="2">
                           <FormGroup row className="mb-3 align-items-center">
                            <Label sm={3} className="text-end fw-medium">Ehliyet Sınıfı</Label>
                            <Col sm={4}><Input type="text" name="licenseClass" value={formData.licenseClass} onChange={handleInputChange} /></Col>
                        </FormGroup>
                        <FormGroup row className="mb-3 align-items-center">
                            <Label sm={3} className="text-end fw-medium">Lisans numarası</Label>
                            <Col sm={4}><Input type="text" name="licenseNumber" value={formData.licenseNumber} onChange={handleInputChange} /></Col>
                            <Col sm={1}><i className="mdi mdi-help-circle fs-5 text-dark cursor-pointer"></i></Col>
                        </FormGroup>
                      </TabPane>
                      <TabPane tabId="3"><div className="text-center text-muted py-5">Şu anda uyarınız yok.</div></TabPane>

    <TabPane tabId="4">
                        <div className="bg-light p-3 rounded mb-4 text-dark fw-medium">
                          <i className="mdi mdi-information text-dark me-2"></i> Aşağıdaki belgeler işbirliğimiz için gereklidir.<br/>
                          <small className="text-muted ms-4 fw-normal">Dosyalarınızın ağırlığı 8 mb'den fazla olmadığından emin olun.</small>
                        </div>
                        
                        {["Kimlik Belgesi (Identity)", "Ehliyet (License)", "Adli Sicil (Criminal Record)", "Vergi Levhası (Tax Plate)"].map((docName, idx) => (
                            <Row key={idx} className="align-items-center border-bottom py-3">
                                <Col sm={3} className="text-end">{docName}</Col>
                                <Col sm={5}>
                                    <Button color="light" outline className="border text-dark">
                                        <i className="mdi mdi-upload fw-bold"></i> Dosya Yükle
                                    </Button>
                                </Col>
                            </Row>
                        ))}
                      </TabPane>


                      {/* SEKME 5: FİRMA / FATURALANDIRMA (Artık tamamen düzenlenebilir) */}
                      <TabPane tabId="5">
                        <div className="bg-light p-3 rounded mb-4 text-dark fw-medium">
                          <i className="mdi mdi-information text-dark me-2"></i> Firma, banka ve vergi bilgilerinizi aşağıdan güncelleyebilirsiniz.
                        </div>

                        {/* Şirket Resmi Bilgileri */}
                        <div className="border-bottom pb-4 mb-4">
                            <h5 className="mb-4">Firma Bilgileri</h5>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Şirket Adı</Label>
                                <Col sm={5}><Input type="text" name="companyName" value={formData.companyName} onChange={handleInputChange} placeholder="Şahıs firmanızın veya şirketinizin adı" /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Şirket türü</Label>
                                <Col sm={5}>
                                    <Input type="select" name="companyType" value={formData.companyType} onChange={handleInputChange}>
                                        <option>Serbest meslek sahibi</option>
                                        <option>Şahıs Şirketi</option>
                                        <option>Limited Şirket (LTD)</option>
                                        <option>Anonim Şirket (AŞ)</option>
                                    </Input>
                                </Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Siren / Şirket Numarası</Label>
                                <Col sm={5}><Input type="text" name="companyNumber" value={formData.companyNumber} onChange={handleInputChange} placeholder="Ticaret Sicil No" /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">KDV / Vergi No</Label>
                                <Col sm={5}><Input type="text" name="vatNumber" value={formData.vatNumber} onChange={handleInputChange} placeholder="Vergi Numaranız" /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Vergi Dairesi</Label>
                                <Col sm={5}><Input type="text" name="taxOffice" value={formData.taxOffice} onChange={handleInputChange} placeholder="Bağlı olduğunuz vergi dairesi" /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Şirket adresi:</Label>
                                <Col sm={5}>
                                    <Input type="text" placeholder="Fatura adresinizi girin..." name="companyAddress" value={formData.companyAddress} onChange={handleInputChange} className="mb-2" />
                                    <small className="text-dark fw-medium">Dikkat, bu adres faturanızda görünecek</small>
                                </Col>
                            </FormGroup>
                        </div>

                        {/* Finansal Tercihler ve Banka */}
                        <div>
                            <h5 className="mb-4">Banka ve Finansal Tercihler</h5>
                            <FormGroup row className="mb-3 mt-4">
                                <Label sm={3} className="text-end fw-medium">Hesap Sahibi</Label>
                                <Col sm={5}><Input type="text" name="holderName" value={formData.holderName} onChange={handleInputChange} placeholder="Banka hesabındaki ad soyad/unvan" /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">Banka Adı</Label>
                                <Col sm={5}><Input type="text" name="bankName" value={formData.bankName} onChange={handleInputChange} placeholder="Örn: Garanti BBVA" /></Col>
                            </FormGroup>
                            <FormGroup row className="mb-3">
                                <Label sm={3} className="text-end fw-medium">IBAN</Label>
                                <Col sm={5}><Input type="text" name="iban" value={formData.iban} onChange={handleInputChange} placeholder="TR..." /></Col>
                            </FormGroup>
                            
                            <FormGroup row className="mb-3 mt-4">
                                <Label sm={3} className="text-end fw-medium">KDV'ye tabi</Label>
                                <Col sm={5} className="d-flex flex-column gap-2 mt-2">
                                    <Label className="mb-0"><Input type="radio" name="subjectToVAT" value="true" checked={formData.subjectToVAT === "true"} onChange={handleInputChange} className="me-2"/>EVET</Label>
                                    <Label className="mb-0"><Input type="radio" name="subjectToVAT" value="false" checked={formData.subjectToVAT === "false"} onChange={handleInputChange} className="me-2"/>HAYIR</Label>
                                </Col>
                            </FormGroup>
                        </div>
                      </TabPane>

                    </TabContent>
                  )}
                  
                  {/* Tüm Sekmelerde Ortak Görünecek İşlem Butonları */}
                  {!isLoading && (
                    <div className="d-flex gap-2 mt-5 border-top pt-4">
                      <Button color="success" className="d-flex align-items-center fw-medium px-4" onClick={handleSave} disabled={isSaving}>
                        <i className="mdi mdi-check me-2"></i> {isSaving ? "Kaydediliyor..." : "Tüm Bilgileri Kaydet"}
                      </Button>
                    </div>
                  )}

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Hesabim;